<template>
    <div class="float-left">
        <i
            class="fa fa-search-plus fa-lg icon-button text-primary"
            title="Informações e Documentos da Meta de Consultoria"
            @click.stop="abrirModal()"
        ></i>

        <b-modal 
            @show="preencherModal()"
            size="xl"
            v-model="mostrarModal"
            no-close-on-backdrop>
            <div slot="modal-title">Informações e Documentos da Meta de Consultoria</div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="16" md="6">
                        <b-form-group>
                            <label class="required">
                                Nome da Meta
                            </label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    v-model="metaConsultoria.nomeMeta"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group >
                            <label class="required">CPF/CNPJ do Cliente</label>
                            <b-input-group>
                                <b-form-input 
                                v-mask="cpfCnpjMask()" 
                                v-model="metaConsultoria.cpfCliente"
                                disabled
                                />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">Tipo do Cliente</label>

                            <b-form-select 
                            :options="tipoClienteFormatado" 
                            v-model="this.metaConsultoria.tipoCliente"
                            text-field="descricao"
                            value-field="codigo" 
                            disabled>
                            </b-form-select>

                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">Código do Cliente</label>
                            <b-input-group>
                                <b-form-input type="number" v-model="metaConsultoria.codCliente" disabled>
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">Início Atendimento</label>
                            <b-input-group >
                                <b-form-input
                                    v-model="dataInicioAtedimentoFormatada "
                                     disabled>
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    
                    <b-col sm="24" md="3">
                        
                        <b-form-group>
                            <label class="required">Final Atendimento</label>
                            <b-input-group >
                                <b-form-input 
                                    v-model="dataFinalAtedimentoFormatada"
                                    disabled>
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label class="required">Tipo</label>
                            <b-input-group disabled>
                                <b-form-select :options="tipos" v-model="selectedTipo" optionLabel="descricao"
                                optionValue="codigo" disabled></b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label class="required">Abordagem</label>
                            <b-input-group>
                                <b-form-select 
                                    :options="abordagens" 
                                    v-model="this.metaConsultoria.abordagem" 
                                    optionLabel="descricao"
                                    optionValue="codigo" disabled>
                                </b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="18" md="3">
                        <b-form-group>
                            <label class="required">CPF do Gestor Responsável</label>
                            <b-input-group disabled>
                                <b-form-input 
                                    v-mask="'###.###.###-##'" 
                                    type="text"
                                    v-model="metaConsultoria.cpfResponsavel" 
                                    disabled>
                                </b-form-input >
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="18" md="3">
                        <b-form-group>
                            <label class="required">Cargo Horária</label>
                            <b-input-group>
                                <b-form-input type="number" v-model="metaConsultoria.cargaHoraria" disabled></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">Tipo da Realização</label>
                            <b-input-group>
                                <b-form-input type="text" v-model="metaConsultoria.tipoRealizacao" disabled>
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    
                    <b-col sm="18" md="3">
                        <b-form-group>
                            <label class="required">Projeto</label>
                            <b-input-group>
                            <b-form-select
                               b-form-select :options="projetoMeta" v-model="this.metaConsultoria.codProjeto" text-field="nomePratif"
                                    value-field="codPratif"  disabled></b-form-select> 
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="18" md="3">
                        <b-form-group>
                            
                            <label class="required">Ação</label>
                            <b-input-group>
                                <b-form-select :options="acaoMeta" v-model="this.metaConsultoria.codAcao" text-field="nomeAcao"
                                    value-field="codAcaoSeq"  disabled></b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label class="required">Instrumento</label>
                            <b-input-group>
                                <b-form-select 
                                :options="instrumentoMeta" 
                                v-model="this.metaConsultoria.codInstrumento"
                                text-field="descCategoria" value-field="codCategoria"
                                disabled></b-form-select>
                            </b-input-group> 
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label class="required">Tema</label>
                            <b-input-group>
                                <b-form-select :options="temaMeta" 
                                v-model="this.metaConsultoria.codTema" 
                                text-field="descAreaTematica"
                                    value-field="codAreaTematica"  disabled></b-form-select>
                            </b-input-group> 
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        
                        <b-form-group>
                            
                            <label class="required">Código de Realização</label>
                            <b-input-group>
                                <b-form-input type="number" v-model="metaConsultoria.codRealizacao" disabled>
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    
                    <b-col sm="24" md="9">
                        <b-form-group>
                            <label class="text-nowrap required">Descrição do Atendimento</label>
                            <b-input-group>
                                <b-form-input type="text" v-model="this.metaConsultoria.descricaoAtendimento" disabled></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    
                    <b-col sm="12" md="12">
                        <b-card no-body>
                            <b-card-header>
                                
                                <span class="h5"> Documentos da Meta</span>
                            </b-card-header>
                            <b-card-body>
                                <app-tabela
                                    :itens="documentosConsultoria"
                                    :campos="campos"
                                    :itensPorPagina="itensPorPagina"
                                    :bordered="false"
                                    :small="false">
                                    <template slot="botoes">
                                        <b-button-group class="float-right">
                                            <inserir-documentos-meta-consultoria
                                                :dataServicos="dataServicos"
                                                class="mr-2"
                                                :consultoria="metaConsultoria"
                                                @atualizarLista="obterDocumentos()">
                                            </inserir-documentos-meta-consultoria>
                                        </b-button-group>
                                    </template>
                                    <template slot="acoes" slot-scope="data">
                                        <span
                                            class="text-danger float-left mr-1">
                                            <i
                                                class="fa fa-trash fa-lg icon-button"
                                                title="Excluir Documento"
                                                @click.stop="confirmarExcluirDocumento(data)"
                                            ></i>
                                        </span>
                                        <span
                                            class="text-success float-left mr-1">
                                            <i
                                                class="fa fa-download fa-lg icon-button"
                                                title="Download"
                                                @click.stop="confirmarDownload(data)"
                                            ></i>
                                        </span>
                                    </template>
                                </app-tabela>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Fechar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import InserirDocumentosMetaConsultoria from './InserirDocumentosMetaConsultoria'

export default {
    props: {
        evento: {
            type: Object,
            default: () => ({})
        },
        metaConsultoria: {
            type: Object,
            default: () => ({})
        },

        acao: {
            type: Object,
            default: () => ({})
        },

        dataServicos: {
            type: Object,
        },

        permiteInserirCancelarDocumentosConsultoria: {
            type: Boolean,
            default: () => false
        },
    },

    components: {
        InserirDocumentosMetaConsultoria,
    },

    data() {
        return {
            mostrarModal: false,
            arquivo: [],
            erros: [],
            itensPorPagina: 5,
            tipos: [
                { value: 0, text: 'Consultoria Convênio Transferência' }
            ],
            selectedTipo: 0,
            tipoClienteFormatado:[],
            projetoMeta:[],
            acaoMeta:[],
            instrumentoMeta:[],
            temaMeta:[],
            abordagens: [
                { value: 0, text: 'INDIVIDUAL' },
                { value: 1, text: 'GRUPAL' },
                { value: 2, text: 'UNIVERSAL' },
            ],
            dataInicioAtedimentoFormatada:"" ,
            dataFinalAtedimentoFormatada:"",
            documentosConsultoria: [],
            campos: [
                {
                    key: 'descricaoArquivo',
                    label: 'Nome do Arquivo',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ]
        }
    },

    methods: {
        preencherModal(){

            this.dataInicioAtedimentoFormatada = this.$moment(this.metaConsultoria.inicioAtendimento).format('DD/MM/YYYY') 
            this.dataFinalAtedimentoFormatada = this.$moment(this.metaConsultoria.finalAtendimento).format('DD/MM/YYYY') 
            this.temaMeta=[{
                descAreaTematica:this.metaConsultoria.tema,
                codAreaTematica:this.metaConsultoria.codTema
            }]
            this.instrumentoMeta=[{
                descCategoria:this.metaConsultoria.instrumento,
                codCategoria:this.metaConsultoria.codInstrumento
            } ]
            this.tipoClienteFormatado=[{
                codigo:this.metaConsultoria.tipoCliente,
                descricao: this.metaConsultoria.tipoCliente == 0 ? 'CNPJ':'CPF'
            }],
            this.projetoMeta=[{
                nomePratif:this.metaConsultoria.projeto,
                codPratif:this.metaConsultoria.codProjeto
            } ],
            this.acaoMeta=[{
                nomeAcao:this.metaConsultoria.acao,
                codAcaoSeq:this.metaConsultoria.codAcao
            } ]
           

        },
        cpfCnpjMask() {
            return this.metaConsultoria.tipoCliente == '1' ? '###.###.###-##' : '##.###.###/####-##';
        },
        abrirModal() {
          
            if (!this.desativarBotao) {
                this.mostrarModal = true
                this.obterDocumentos()
            }
        },

        fecharModal() {
            this.mostrarModal = false
        },

        fecharModalImagem() {
            this.arquivo = null
        },

        confirmarExcluirDocumento(obj) {
            
            this.$swal({
                title: 'Excluir',
                html: `Deseja Excluir o Documento <b>${obj.descricaoArquivo}</b> ?`,
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.ExcluirDocumento(obj.idDocumento)
                }
            })
        },

        ExcluirDocumento(id) {
            this.$store.dispatch('addRequest')
            this.dataServicos.excluirDocumentoMetaConsultoria(id).then(
                (response) => {
                    if (response) {
                        this.obterDocumentos()
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterDocumentos() {
        
            this.$store.dispatch('addRequest')
            this.dataServicos.obterDocumentosMetaConsultoria(
                this.metaConsultoria.idMetaConsultoria
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.documentosConsultoria = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarDownload(doc) {
            this.$swal({
                title: 'Download',
                html: `Confirma o Download do Documento <b>${doc.descricaoArquivo}</b> ?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.download(doc)
                }
            })
        },

        download(doc) {
            this.$store.dispatch('addRequest')
            this.dataServicos.downloadDocumentoMetaConsultoria(
                this.metaConsultoria.idMetaConsultoria,
                doc.idDocumento
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro no Download!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, doc.vcNomeArquivo)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
